import type { IFilter, ISingleFilter, ISingleOrder } from '@chax-at/prisma-filter-common';

type TParamValue = string | number | symbol | boolean | null | undefined;

export function buildQueryParams(
  paramName: string,
  paramData: ISingleFilter<TParamValue>[] | ISingleOrder<TParamValue>[],
): Partial<Record<string, string | string[]>> {
  const result: Partial<Record<string, string | string[]>> = {};

  for (let i = 0; i < paramData.length; i++) {
    for (const [key, value] of Object.entries(paramData[i])) {
      if (!['field', 'dir', 'type', 'value'].includes(key)) {
        continue;
      }

      const assembledKey = `${paramName}[${i}][${key}]`;

      /**
       * for FilterOperationType.In
       *
       * filter[x][field]=<fieldName>
       * & filter[x][type]=in
       */
      if (Array.isArray(value)) {
        if (value.length === 0) {
          result[assembledKey] = '';
        } else {
          /** & filter[x][value][]=<value> */
          result[`${assembledKey}[]`] = value.map(stringifyValue);
        }
      } else {
        result[assembledKey] = stringifyValue(value);
      }
    }
  }

  return result;
}

export function createFilterParams(filter: IFilter | undefined): Partial<Record<string, string | number | string[]>> {
  return {
    ...(filter?.offset && { offset: filter.offset }),
    ...(filter?.limit && { limit: filter.limit }),
    ...(filter?.filter && buildQueryParams('filter', filter.filter)),
    ...(filter?.order && buildQueryParams('order', filter.order)),
  };
}

function stringifyValue(value: unknown): string {
  return value != null ? value.toString() : '';
}
